<script setup>
import { reactive,ref,inject,onMounted,provide  } from 'vue'
import { ElMessage } from 'element-plus'
import axios from 'axios';
import { useMemberStore } from '../../stores';
const userStore = useMemberStore();

const size = ref('default')
const labelPosition = ref('right')
const headers = ref({
	'Authorization': `${userStore.profile?.token}`,
})
const departmentInfos = ref([])
onMounted(async()=>{
	const response = await axios.post('/hrm/department/queryList', {
	  pageNo:1,
	  pageSize:50,
	}, {
	  headers: {
	    'Content-Type': 'application/json',
		Authorization: `${userStore.profile?.token}`,
	  }
	});
	if(response.data.status===0){
		response.data.data.map(item=>{
			departmentInfos.value.push({
				label:item.departmentname,
				value:item.id
			})
		})
	}
})
const ruleFormRef = ref(null)
const validatePass = (rule, value, callback) => {
  if (value === '') {
    callback(new Error('请输入密码'))
  } else {
    callback()
  }
}
const validatePass2 = (rule, value, callback) => {
  if (value === '') {
    callback(new Error('请再次输入密码'))
  } else if (value !== sizeForm.value.password) {
    callback(new Error("2次输入密码不一致!"))
  } else {
    callback()
  }
}

const validateAccount = async(rule, value, callback) => {
  if (value !== '') {
	//查询接口 账号是否已被占用
	const response = await axios.post('/hrm/user/queryInfoByAcc', {
	  account:value
	}, {
	  headers: {
		'Content-Type': 'application/json',
		Authorization: `${userStore.profile?.token}`,
	  }
	});
	if(response.data.status===0){
		callback(new Error("账号已被占用!"))
	}
   } else {
    callback()
  }
}
const rules = ref({
  password: [{ validator: validatePass, trigger: 'blur' }],
  rpassword: [{ validator: validatePass2, trigger: 'blur' }],
  account:[{ validator: validateAccount, trigger: 'blur' }],
})
const sizeForm = ref({
	account:'',
	name:'',
	password:'',
	rpassword:'',
	departmentid:'',
	tenantKey:''
});
const onSubmit=async()=> {
	let isNull = false;
	Object.keys(sizeForm.value).forEach(key=>{
		if(sizeForm.value[key]===''){
			isNull = true;
		}
	})
	if(!isNull){
		ruleFormRef.value.validate(async valid=>{
			if(valid){
				const response = await axios.post('/hrm/user/add', {
				  ...sizeForm.value
				}, {
				  headers: {
					'Content-Type': 'application/json',
					Authorization: `${userStore.profile?.token}`,
				  }
				});
				if(response.data.status===0){
					ElMessage.success('添加成功!')
					sizeForm.value = {}
				}
			}else{
				ElMessage.error('校验不通过!')
			}
		})
		
	}else{
		ElMessage.error('所有信息不可为空!')
	}
}
const generateKey=async(e)=>{
	const response = await axios.post('/hrm/user/generateKey', {
	  check:e
	}, {
	  headers: {
		'Content-Type': 'application/json',
		Authorization: `${userStore.profile?.token}`,
	  }
	});
	if(response.data.status===0){
		sizeForm.value.tenantKey = response.data.msg
	}
}
</script>
<template>
	<el-form
	    ref="ruleFormRef"
	    :model="sizeForm"
	    label-width="auto"
	    :label-position="labelPosition"
	    :size="size"
		:rules="rules"
	>
		<div style="display: flex;">
			<el-form-item label="登录账号" style="width: 96%;" prop="account">
			  <el-input class="w-50 m-2" clearable v-model="sizeForm.account" />
			</el-form-item>
		</div>
		<div style="display: flex;">
			<el-form-item label="名称" style="width: 96%;">
			  <el-input class="w-50 m-2" clearable v-model="sizeForm.name"/>
			</el-form-item>
		</div>
		<div style="display: flex;">
			<el-form-item label="密码" style="width: 96%;" prop="password">
			  <el-input v-model="sizeForm.password" class="w-50 m-2" type="password" placeholder="请输入密码" show-password  autocomplete="off"/>
			</el-form-item>
		</div>
		<div style="display: flex;">
			<el-form-item label="确认密码" style="width: 96%;" prop="rpassword">
			  <el-input v-model="sizeForm.rpassword" class="w-50 m-2" type="password" placeholder="请确认密码" show-password autocomplete="off"/>
			</el-form-item>
		</div>
		<div style="display: flex;">
			<el-form-item label="所属部门" style="width: 96%;" prop="departmentid">
			  <el-select
			    v-model="sizeForm.departmentid"
			    collapse-tags
			    placeholder="选择所属部门"
			    style="width: 360px"
			  >
			    <el-option
			  	v-for="item in departmentInfos"
			  	:key="item.value"
			  	:label="item.label"
			  	:value="item.value"
			    />
			  </el-select>
			</el-form-item>
		</div>
		<div style="display: flex;">
			<el-form-item label="租户Key" style="width: 96%;">
			  <el-input class="w-50 m-2" v-model="sizeForm.tenantKey"/>
			  <el-text class="mx-1" type="success" @click="generateKey(1)">当前用户租户编号</el-text>&nbsp;&nbsp;
			  <el-text class="mx-1" type="info" @click="generateKey(0)">随机</el-text>
			</el-form-item>
		</div>
		<div style="display: flex;justify-content: center;">
			<el-form-item>
		      <el-button type="primary" @click="onSubmit">保存</el-button>
		    </el-form-item>
		</div>
	</el-form>
</template>

<style scoped>
	.avatar-uploader .avatar {
	  width: 90px;
	  height: 90px;
	  display: block;
	}
	.avatar-uploader .el-upload {
	  border: 1px dashed var(--el-border-color);
	  border-radius: 6px;
	  cursor: pointer;
	  position: relative;
	  overflow: hidden;
	  transition: var(--el-transition-duration-fast);
	}
	
	.avatar-uploader .el-upload:hover {
	  border-color: var(--el-color-primary);
	}
	
	.el-icon.avatar-uploader-icon {
	  font-size: 28px;
	  color: #8c939d;
	  width: 90px;
	  height: 90px;
	  text-align: center;
	}
</style>